// extracted by mini-css-extract-plugin
export default {"box":"modal_box__GzPeT","box-content":"modal_box-content__JL37I"};